import script from "./PatientName.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientName.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./PatientName.vue3.vue?vue&type=style&index=0&id=0696d8c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0696d8c4"]])

export default __exports__